<template>
    <div class="building">
        <div class="building-list">
            <div class="no-data" v-show="!isbuildata">
                暂无楼盘动态！
            </div>
            <div v-for="(item, index) in buildList" :key="index">
                <div class="build-info">
                    <div class="spot"><span></span></div>
                    <div class="build-time">
                    <span>{{item.pushTime | formatTime}}</span> <span v-show="item.mark">{{item.mark}}</span>
                    </div>
                    <div class="build-price">
                    {{item.title}}
                    </div>
                    <div class="build-content">
                    {{item.description}}
                    </div>
                </div>
            </div>
        </div>
         <BtnBackLayout4></BtnBackLayout4>
    </div>
</template>
<script>
const BtnBackLayout4 = () => import("@/components/btn_back_layout4");
import * as comreq from "@/utils/comreq";
import { mapState, mapMutations } from "vuex";
import util from "@/utils/utils";
export default{
    data(){
        return{
            isbuildata: false,
            buildList: [],
            PageId: 0,
        }
    },
    components: {
        BtnBackLayout4
    },
    computed: {
    ...mapState(["userInfo", "pageInfo"])
    },
    filters: {
        formatTime(time){
        let date = new Date(time)
        return util.formatTime5(date)
        }
    },
    created(){
        
    },
    mounted() {
    //获取当前城市
    util.checkMapStateCallback(this, ["pageInfo","userInfo"]).then(() => {
      this.PageId= this.pageInfo.PageId;
      comreq.getBuildingNews(this.PageId).then((data)=>{
           if(data.code==0){
             if(data.obj==""||data.obj.total==0){
                 this.isbuildata = false;
             }else{
                 this.isbuildata = true;
                 this.buildList = data.obj.list
             }
             console.log('=====>6', data)
           }
      })
    });
  }
}
</script>
<style scoped lang="css">
.building{
    width: 100%;
    padding-top: .3rem;
}
.building-list{
    width: 90%;
    margin: 0 auto;
}
.spot{
    position: absolute;
    top: 0.6rem;
    left: -.5rem;
    width: .3rem;
    height: .3rem;
    background: #eaaa7d;
    border-radius: 50%;
}
.spot>span{
    width: .1rem;
    height: .1rem;
    border-radius: 50%;
    margin: .1rem;
    background: #d46618;
    display: block;
}
.building-list .no-data{
    width: 100%;
    height: .8rem;
    line-height: .8rem;
    text-align: center;
}
.build-info{
  width: 90%;
  margin: 0 auto;
  padding: .5rem 0;
  position: relative;
}
.build-info .build-time{
  width: 100%;
  line-height: .5rem;
}
.build-info .build-time>span{
  font-size: .36rem;
  color: #333;
  margin-right: .2rem;
}
.build-info .build-time>span:nth-child(2){
  font-size: .24rem;
  color:#FFA45B;
  background: #ecd9c9;
  padding: .05rem .1rem;
}
.build-price{
  padding: .2rem 0;
  width: 100%;
  line-height: .5rem;
  font-size: .32rem;
}
.build-content{
  padding: .2rem 0;
  color: #999;
  font-size: .26rem;
  line-height: .4rem;
  min-height: 1rem;
}
</style>